import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslocoPipe } from '@jsverse/transloco';

import { BaseColumnComponent } from '~components/dynamic-table/column-components/base-column.component';
import { IconColumnModel } from '~components/dynamic-table/models/column-types/icon-column.model';
import { Identifyable } from '~core/abstractions/identifyable';
import { IconModel } from '~core/models/icon.model';
import { OptionalType } from '~shared/core/types/optional.type';

@Component({
    selector: 'arc-icon-column',
    templateUrl: './icon-column.component.html',
    styleUrls: ['./icon-column.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [MatIcon, NgStyle, MatTooltip, TranslocoPipe]
})
export class IconColumnComponent<T extends Identifyable<TId>, TId = number> extends BaseColumnComponent<T, TId> {
    @HostBinding('class') override classes = 'w-full h-full grid place-items-center';

    get iconColumnModel(): IconColumnModel {
        return new IconColumnModel(this.columnModel);
    }

    get icon(): OptionalType<string> {
        return this.getModel()?.name ?? undefined;
    }

    get color(): string {
        const modelColor = this.getModel()?.color;
        return modelColor ? `var(--${modelColor})` : '';
    }

    get tooltip(): string {
        return this.getModel()?.tooltip ?? '';
    }

    getModel(): OptionalType<IconModel> {
        return this.iconColumnModel.iconMapping?.get(this.getItemValue(this.columnModel.propertyName));
    }
}
